import { render, staticRenderFns } from "./BRICertificate.vue?vue&type=template&id=55ce8d12&scoped=true"
import script from "./BRICertificate.vue?vue&type=script&lang=js"
export * from "./BRICertificate.vue?vue&type=script&lang=js"
import style0 from "./BRICertificate.vue?vue&type=style&index=0&id=55ce8d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ce8d12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
